import React, { useState } from "react";
import { useAppDispatch } from "../../hooks/reduxHooks";
import { markCtaAsResolvedApi } from "../../services/cta.service";

import { Modal, Descriptions, Tag, Avatar, Typography, Input, message } from "antd";
import { UserOutlined, TagOutlined, PhoneOutlined, MailOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { logout } from "../../store/slices/profile.slice";
import prettifyString from "../../utils/prettifyString";
import { set } from "lodash";
import { formatDateTime } from "../../utils/formatDateTime";
const { Text } = Typography;

const ResolveCtaDialog = ({ visible, ctaData, onClose, onSuccess }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [remarks, setRemarks] = useState("");
  const [remarksError, setRemarksError] = useState("");
  const normalizedCtaType = String(ctaData?.type || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");
  const isEndConversationType = normalizedCtaType === "end_conversation";

  if (!visible || !ctaData) return null;

  const handleResolveWithRemarks = () => {
    const trimmedRemarks = remarks.trim();
    if (isEndConversationType && !trimmedRemarks) {
      setRemarksError("Please provide remarks to resolve this ticket.");
      return;
    }
    dispatch(
      markCtaAsResolvedApi({
        data: { ...ctaData, remarks: trimmedRemarks },
        finalCallback: () => {
          setRemarks("");
          onClose();
          setRemarksError("");
        },
        successCallback: () => {
          onSuccess();
        },
        failureCallback: (error) => {
          // console.error("Failed to resolve CTA:", error?.response?.data?.detail);
          message.error(error?.response?.data?.detail || "Failed to resolve CTA. Please try again.");
        },
      })
    );
  };

  return (
    <Modal
      title="Mark As Resolved"
      open={visible}
      onOk={handleResolveWithRemarks}
      width={700}
      onCancel={() => {
        setRemarks("");
        onClose();
        setRemarksError("");
      }}
      okText="Resolve"
      cancelText="Cancel"
      okButtonProps={{
        style: {
          backgroundColor: "#3D90D7",
          borderColor: "#3D90D7",
          color: "#fff",
          zIndex: "10001",
        },
      }}
    >
      {ctaData ? (
        <div>
          <Descriptions
            bordered
            column={1}
            labelStyle={{
              width: "30%",
              fontWeight: 500,
            }}
            contentStyle={{
              width: "70%",
            }}
          >
            {/* <Descriptions.Item label="Customer Name">
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <Avatar icon={<UserOutlined />} />
                <Text strong>{ctaData.customer_name || "N/A"}</Text>
              </div>
            </Descriptions.Item> */}
            {
              ctaData.customer_name || ctaData.extra_info?.customer_name ? (
                <Descriptions.Item label="Customer Name">
                  <div
                    style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <Avatar icon={<UserOutlined />} />
                    <Text strong>
                      {ctaData.customer_name || ctaData.extra_info?.customer_name || "N/A"}
                    </Text>
                  </div>
                </Descriptions.Item>
              ) : null
            }
            {
              ctaData.customer_phone_number || ctaData.extra_info?.contact_number ? (
                <Descriptions.Item label="Contact Number">
                  <Text>
                    <PhoneOutlined style={{ marginRight: "8px" }} />
                    {ctaData.customer_phone_number || ctaData.extra_info?.contact_number || "N/A"}
                  </Text>
                </Descriptions.Item>
              ) : null
            }
            {
              ctaData.customer_email || ctaData.extra_info?.email ? (
                <Descriptions.Item label="Email Address">
                  <Text>
                    <MailOutlined style={{ marginRight: "8px" }} />
                    {ctaData.customer_email || ctaData.extra_info?.email || "N/A"}
                  </Text>
                </Descriptions.Item>
              ) : null
            }
            <Descriptions.Item label="Description">
              <span dangerouslySetInnerHTML={{ __html: (ctaData.description || "No description provided")
                .replace(/\n\n/g, '<hr style="border: none; border-top: 1px solid #ddd; margin: 10px 0;">')
                .replace(/\n/g, '<br>')
                .replace(/\((\d{4}-\d{2}-\d{2}:\d{2}:\d{2}:\d{2})\)/g, (match, dateStr) => {
                  const formattedDate = formatDateTime({ date: dateStr.replace(':', 'T'), withTime: true });
                  return '<b>(' + formattedDate + ')</b>';
                }) }} />
            </Descriptions.Item>
            <Descriptions.Item label="Type">
              <Tag icon={<TagOutlined />}>{ctaData.type && prettifyString(ctaData.type) || "N/A"}</Tag>
            </Descriptions.Item>
          </Descriptions>
        </div>
      ) : (
        <Text>No data available.</Text>
      )}
      <Text
        orientation="left"
        strong
        style={{
          fontSize: "16px",
          marginTop: "20px",
          marginBottom: "8px",
          display: "block",
          fontWeight: 500,
        }}
      >
        Remarks {!isEndConversationType ? "(optional)" : <span style={{ color: "red" }}>*</span>}
      </Text>

      <div>
        <Input.TextArea
          rows={4}
          value={remarks}
          onChange={(e) => {
            setRemarks(e.target.value);
            setRemarksError("");
          }}
          placeholder="Enter remarks for resolving the ticket."
          status={remarksError ? "error" : ""}
        />
        {remarksError && <p style={{ color: "red", marginTop: "4px", fontSize: "12px" }}>{remarksError}</p>}
      </div>
    </Modal>
  );
};

export default ResolveCtaDialog;
